import { Cookies } from 'react-cookie';

import { AssignIntakeTokenRequest, CreateIntakeDeviceRequest, IntakeTokenDevices } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

const auth = () => ({ headers: { Authorization: new Cookies().get('local_access_token') } });

export const createIntakeDevice = async (request: CreateIntakeDeviceRequest) => {
  const { data } = await axiosInterceptor.post<{ id: number; token: string | null }>(
    'v1/admin/device-intake/devices',
    request,
    auth(),
  );
  return data;
};

export const assignIntakeToken = async ({ token, ...request }: AssignIntakeTokenRequest) => {
  const url = token ? `v1/admin/device-intake/tokens/${token}` : 'v1/admin/device-intake/tokens';
  const { data } = await axiosInterceptor.post<{ token: string; updated: number }>(url, request, auth());
  return data;
};

export const getIntakeTokenDevices = async (token: string) => {
  const { data } = await axiosInterceptor.get<IntakeTokenDevices>(`v1/admin/device-intake/tokens/${token}`, auth());
  return data;
};
